import React, { useState } from "react";
import { MobileUnderCalAds } from "../../Ads";
const SeriesResistorCalculator = () => {
  const [resistances, setResistances] = useState("");
  const [totalResistance, setTotalResistance] = useState(null);
  const [error, setError] = useState("");
  const calculateTotalResistance = (resistancesArray) => {
    return resistancesArray.reduce((acc, res) => acc + res, 0);
  };
  const handleCalculate = () => {
    try {
      const resistancesArray = resistances
        .split(",")
        .map((res) => parseFloat(res.trim()));
      if (
        resistancesArray.some(isNaN) ||
        resistancesArray.some((res) => res <= 0)
      ) {
        throw new Error("Veuillez entrer des valeurs de résistance valides et positives.");
      }
      const total = calculateTotalResistance(resistancesArray);
      setTotalResistance(total);
      setError("");
    } catch (err) {
      setError(err.message);
      setTotalResistance(null);
    }
  };
  return (
    <div className="ltr">
      <div className="row">
        <div className="col-12 col-md-8">
          <div className="border border-light">
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "17px" }}>Calculatrice de résistances en série</h2>
                </div>
                <div className="row">
                  <div>
                    <p>
                      Veuillez entrer les valeurs de résistance connectées en série, séparées par une virgule (,) pour calculer la résistance totale.
                    </p>
                  </div>
                </div>
                <MobileUnderCalAds />
                <hr />
                <div dir="ltr">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Entrez les valeurs de résistance
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="Exemple : 10, 20, 30"
                        value={resistances}
                        onChange={(e) => setResistances(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer                    </button>
                  </div>
                  <br />
                  <div>
                    { error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Erreur : {error}
                      </p>
                    ) : (
                      totalResistance !== null && (
                        <div className="p-3 mb-2 bg-success text-white">
                          <p className="text-white">
                            Résistance totale : {totalResistance.toFixed(2)} Ω
                          </p>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
          </div>
        </div>
      </div>
    </div>
  );
};
export default SeriesResistorCalculator;
